var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96.001,
    viewBox: "0 0 96 96.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4b74f4;}.b{fill:rgba(75,116,244,0.3);}.c{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(8 8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0m0-8A48,48,0,1,1-8,40,48.055,48.055,0,0,1,40-8Z",
    transform: "translate(8 8)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 34)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.164,0H4.087A1.164,1.164,0,0,1,5.251,1.164V4.087A1.164,1.164,0,0,1,4.087,5.251H1.164A1.164,1.164,0,0,1,0,4.087V1.164A1.164,1.164,0,0,1,1.164,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.164,0H4.087A1.164,1.164,0,0,1,5.251,1.164V4.087A1.164,1.164,0,0,1,4.087,5.251H1.164A1.164,1.164,0,0,1,0,4.087V1.164A1.164,1.164,0,0,1,1.164,0Z",
    transform: "translate(0 11.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.164,0H4.087A1.164,1.164,0,0,1,5.251,1.164V4.087A1.164,1.164,0,0,1,4.087,5.251H1.164A1.164,1.164,0,0,1,0,4.087V1.164A1.164,1.164,0,0,1,1.164,0Z",
    transform: "translate(0 23.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.164,0H21.952a1.164,1.164,0,0,1,1.164,1.164V4.087a1.164,1.164,0,0,1-1.164,1.164H1.164A1.164,1.164,0,0,1,0,4.087V1.164A1.164,1.164,0,0,1,1.164,0Z",
    transform: "translate(9.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.164,0H21.952a1.164,1.164,0,0,1,1.164,1.164V4.087a1.164,1.164,0,0,1-1.164,1.164H1.164A1.164,1.164,0,0,1,0,4.087V1.164A1.164,1.164,0,0,1,1.164,0Z",
    transform: "translate(9.56 11.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.164,0H21.952a1.164,1.164,0,0,1,1.164,1.164V4.087a1.164,1.164,0,0,1-1.164,1.164H1.164A1.164,1.164,0,0,1,0,4.087V1.164A1.164,1.164,0,0,1,1.164,0Z",
    transform: "translate(9.56 23.342)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.6399b6adf7f52dd0e3480b50a32a2258.svg";
export { ForwardRef as ReactComponent };